"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // reminder to not import AppUI to avoid circular dependencies
var StaticDateDecorator = /*#__PURE__*/function () {
  function StaticDateDecorator(date) {
    var _sanitizedDate;
    _classCallCheck(this, StaticDateDecorator);
    this.date = null;
    if (!date) {
      return;
    }
    var sanitizedDate;
    if (_typeof(date) === 'object' && 'date' in date) {
      sanitizedDate = date['date'];
    } else {
      sanitizedDate = date;
    }
    if (((_sanitizedDate = sanitizedDate) === null || _sanitizedDate === void 0 ? void 0 : _sanitizedDate.length) === 10) {
      this.date = _moment["default"].parseZone(sanitizedDate).toDate();
    } else if ((0, _lodash.isDate)(sanitizedDate)) {
      this.date = sanitizedDate;
    } else {
      this.date = new Date(sanitizedDate);
    }
  }
  return _createClass(StaticDateDecorator, [{
    key: "dateObj",
    get: function get() {
      return this.date;
    }
  }, {
    key: "momentObj",
    get: function get() {
      return (0, _moment["default"])(this.date);
    }

    /**
     * 06/26, 4:00 PM
     */
  }, {
    key: "formatted",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MM/DD, h:mm A');
      }
      return null;
    }

    /**
     * Jun 26, 04:00 PM
     */
  }, {
    key: "formatted3DigitMonth",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MMM D, hh:mm A');
      }
      return null;
    }

    /**
     * Jun 26 '15
     */
  }, {
    key: "formattedDateWithYear",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MMM D \'YY');
      }
      return null;
    }

    /**
     * Jun 26 2015
     */
  }, {
    key: "formattedDateWithFullYear",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MMM D YYYY');
      }
      return null;
    }

    /**
     * June 26 '15
     */
  }, {
    key: "fullTextFormattedDateWithYear",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MMMM D \'YY');
      }
      return null;
    }

    /**
     * June 26, 2015
     */
  }, {
    key: "fullTextFormattedDateWithFullYear",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MMMM D, YYYY');
      }
      return null;
    }

    /**
     * Jun 26, '15, 04:00 PM
     */
  }, {
    key: "formattedDateWithYearAndTime",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MMM D \'YY, hh:mm A');
      }
      return null;
    }

    /**
     * Fri Jun 26, '15, 04:00 PM
     */
  }, {
    key: "formattedDateWithWeekdayYearAndTime",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('ddd MMM D \'YY, hh:mm A');
      }
      return null;
    }

    /**
     * Fri Jun 26 2015 16:00:00 GMT+0200 (Central European Summer Time)
     */
  }, {
    key: "toString",
    get: function get() {
      return this.date && this.date.toString();
    }

    /**
     * Jun 26
     */
  }, {
    key: "formattedDate",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('MMM D');
      }
      return null;
    }

    /**
     * 2015-06-26
     */
  }, {
    key: "dashesWithYear",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('YYYY-MM-DD');
      }
      return null;
    }
    /**
     * 04:00 PM
     */
  }, {
    key: "formattedTime",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('hh:mm A');
      }
      return null;
    }

    /**
     * 3784
     */
  }, {
    key: "daysSince",
    get: function get() {
      if (this.date) {
        var now = (0, _moment["default"])(new Date());
        return (0, _moment["default"])(now).diff(this.date, 'days');
      }
      return null;
    }
  }, {
    key: "relativeTime",
    get: function get() {
      if (this.date) {
        var fromNow = (0, _moment["default"])(this.date).fromNow();
        return fromNow === 'a few seconds ago' ? 'now' : fromNow.replace('minutes', 'mins');
      }
      return null;
    }
  }, {
    key: "relativeDays",
    get: function get() {
      if (this.date) {
        var dayDiff = (0, _moment["default"])(this.date).startOf('day').diff((0, _moment["default"])().startOf('day'), 'days');
        if (dayDiff === 0) {
          return 'today';
        }
        if (dayDiff === -1) {
          return 'yesterday';
        }
        if (dayDiff === 1) {
          return 'tomorrow';
        }
        if (dayDiff < 0) {
          return "".concat(Math.abs(dayDiff), " days ago");
        }
        return "in ".concat(dayDiff, " days");
      }
      return null;
    }
  }, {
    key: "relativeTimeShort",
    get: function get() {
      if (this.relativeTime) {
        return this.relativeTime.replace('ago', '');
      }
      return null;
    }
  }, {
    key: "isFuture",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).isAfter((0, _moment["default"])());
      }
      return false;
    }
  }, {
    key: "isPast",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).isBefore((0, _moment["default"])());
      }
      return false;
    }
  }, {
    key: "isBeforeToday",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).isBefore((0, _moment["default"])().startOf('day'));
      }
      return false;
    }
  }, {
    key: "isBeforeOneDayFromNow",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).isBefore((0, _moment["default"])().add(1, 'days'));
      }
      return false;
    }

    /**
     * Fri Jun 26
     */
  }, {
    key: "formattedWithWeekday",
    get: function get() {
      if (this.date) {
        return (0, _moment["default"])(this.date).format('ddd MMM D');
      }
      return null;
    }
  }]);
}();
var _default = exports["default"] = StaticDateDecorator;